export default defineNuxtPlugin((nuxtApp) => {
    if (process.client) {
       
        const originalReplaceState = history.replaceState;
        const originalPushState = history.pushState;
        let isRedirecting = false;

        // Sobrescrevendo replaceState
        history.replaceState = function (state, title, url) {
            if (url && url.includes("undefined")) {
                //console.warn(`Interceptado replaceState com URL inválida: ${url}`);
                return;
            }
            return originalReplaceState.apply(this, arguments);
        };
    
        // Sobrescrevendo pushState
        history.pushState = function (state, title, url) {
            window.dispatchEvent(new CustomEvent('routeCaptured', {
                detail: {
                    state,
                    url,
                },
            }));

            if (url && url.includes("undefined")) {
                //console.warn(`Interceptado pushState com URL inválida: ${url}`);
                return;
            }

            if (!this) {
                return;
            }

            return originalPushState.apply(this, arguments);
        };
  

        nuxtApp.$router.beforeEach((to, from, next) => {
            const sportsPath = "/sports";
            const sportsHashPrefix = "/sport/";
            // Verifica se a rota é /sports com hash que começa com /sport/
            if (to.path === sportsPath && to.hash.startsWith("#" + sportsHashPrefix) && from.name) {
                
                // Verifica a flag para evitar loops
                if (isRedirecting) {
                    isRedirecting = false;
                    return next(false);
                }

                isRedirecting = true;
                //console.warn(`Redirecionando para a rota corrigida: ${to.fullPath}`);
                nuxtApp.$router.replace(to.fullPath).finally(() => {
                    isRedirecting = false;
                });

                return;
                
            }
            next();
        });
    }
});  